import { Component, computed, inject, input } from '@angular/core';
import { NodePr } from '@app/models/entity.model';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { TextComponent } from '@app/components/text/text.component';
import { ConciergeComponent } from '@app/components/concierge/concierge.component';
import { DrupalService } from '@app/services/drupal.service';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { MediaComponent } from '@app/components/media/media.component';
import { RelatedContentComponent } from '@app/components/related-content/related-content.component';
import { GalleryComponent } from '@app/components/gallery/gallery.component';

@Component({
  selector: 'mobi-node-pr',
  templateUrl: './node-pr.component.html',
  styleUrl: './node-pr.component.scss',
  standalone: true,
  imports: [
    EntitySharedModule,
    HeroTextComponent,
    BreadcrumbComponent,
    ContentSectionComponent,
    TextComponent,
    ConciergeComponent,
    MediaComponent,
    RelatedContentComponent,
    GalleryComponent,
  ],
})
export class NodePrComponent {
  readonly entity = input.required<NodePr>();
  dateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  #drupal = inject(DrupalService);

  locale = computed(() => this.#drupal.language() + '-CH');
  formattdedDate = computed(() => {
    const date = this.entity()?.date.value;
    if (!date) return;
    const dateObj = new Date(date);

    // @ts-ignore
    const dateString = dateObj.toLocaleDateString(this.locale(), this.dateOptions);
    return dateString;
  });

  relatedContentMutable = computed(() => {
    const content = this.entity()?.relatedContent;
    return content ? [...content] : [];
  });
}
